import { render } from "./HowWork.vue?vue&type=template&id=5d81fd0d"
import script from "./HowWork.vue?vue&type=script&lang=js"
export * from "./HowWork.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__